import React, { memo } from 'react'
import { ButtonInterface } from 'common/types/entities/button-interface'
import useWebsiteLoginSubmit from 'src/publisher/hooks/use-website-login-submit'
import { BasePublisherButton } from 'src/publisher/entities/base-publisher-button'

const TEST_ID = 'custom-login-button'

export interface WebsiteLoginButtonProps {
  entity: ButtonInterface
}

const WebsiteLoginButton = ({ entity }: WebsiteLoginButtonProps) => {
  const [isLoading, errors, submit] = useWebsiteLoginSubmit(entity)

  return (
    <BasePublisherButton
      entity={entity}
      isLoading={isLoading}
      errors={errors}
      onClick={submit}
      testId={TEST_ID}
    />
  )
}

export default memo(WebsiteLoginButton)
